import Counter from '~/components/Molecules/Counter/Counter.vue'
import { getDeviceSize } from '~/utils/device'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
    },
    ctaButton: {
      type: Object,
    },
  },

  data() {
    return {
      isMobile: null,
      card: Counter,
      swiperOptions: {
        watchOverflow: true,
        observer: true,
        slidesPerView: 1.2,
        spaceBetween: 24,
        grabCursor: true,
        breakpoints: {
          375: {
            slidesPerView: 2,
            spaceBetween: 28,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkDeviceSize)

      window.dispatchEvent(new Event('resize'))

      this.checkDeviceSize()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceSize)
  },

  methods: {
    checkDeviceSize() {
      const device = getDeviceSize()

      this.isMobile = /mobile(?:\-(?:l|[m]))?/.test(device)
    },
  },
}
